/**
 * @generated SignedSource<<212d0026e59dd1a16c31af165c1d5002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type infographicArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"globalCheckerContent" | "landingBannerInfographicArticle">;
  readonly " $fragmentType": "infographicArticleArticle";
};
export type infographicArticleArticle$key = {
  readonly " $data"?: infographicArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"infographicArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "infographicArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "landingBannerInfographicArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "aee74dd69dc6eb3a6881a6015938b8cb";

export default node;
